import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "@/lib/i18n/useTranslation";
import { SEO } from "@/components/seo/SEO";

const Terms = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Conditions générales d'utilisation"
        description="Consultez les conditions générales d'utilisation d'EasyFinder. Droits, obligations et règles d'utilisation de notre service."
        canonical="/terms"
      />
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/80 border-b border-border">
        <div className="container mx-auto px-4 h-16 flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-xl font-semibold">{t.terms.title}</h1>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-3xl">
        <article className="prose prose-slate max-w-none">
          <p className="text-muted-foreground text-sm mb-8">{t.terms.lastUpdated} : 16 décembre 2024</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.object.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.terms.sections.object.content}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.description.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.terms.sections.description.content}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.account.title}</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">{t.terms.sections.account.intro}</p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              {t.terms.sections.account.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.acceptableUse.title}</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">{t.terms.sections.acceptableUse.intro}</p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              {t.terms.sections.acceptableUse.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.intellectualProperty.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.terms.sections.intellectualProperty.content}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.subscriptions.title}</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              {t.terms.sections.subscriptions.intro}
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              {t.terms.sections.subscriptions.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.liability.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.terms.sections.liability.content}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.termination.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.terms.sections.termination.content}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.modifications.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.terms.sections.modifications.content}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.applicableLaw.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.terms.sections.applicableLaw.content}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">{t.terms.sections.contact.title}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t.terms.sections.contact.content}
              <a href="mailto:contact@easyfinder.fr" className="text-primary hover:underline"> contact@easyfinder.fr</a>
            </p>
          </section>

          <section className="mt-8 pt-8 border-t border-border">
            <p className="text-muted-foreground text-sm">
              {t.terms.seeAlso}{" "}
              <Link to="/privacy" className="text-primary hover:underline">
                {t.terms.privacyPolicy}
              </Link>
            </p>
          </section>
        </article>
      </main>
    </div>
  );
};

export default Terms;
